
export function searchAuditLog(auditLogs,search){
    if(search) {
        return auditLogs.filter(arr => arr.modifiedBy.toLowerCase().includes(search.toLowerCase()))
    }
    return auditLogs
}